import { render } from "./PayrollClientExport.vue?vue&type=template&id=508e52b5&scoped=true"
import script from "./PayrollClientExport.vue?vue&type=script&lang=js"
export * from "./PayrollClientExport.vue?vue&type=script&lang=js"

import "./PayrollClientExport.vue?vue&type=style&index=0&id=508e52b5&scoped=true&lang=css"
import "./PayrollClientExport.vue?vue&type=style&index=1&id=508e52b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508e52b5"]])

export default __exports__